module.exports = __webpack_public_path__ + "static/media/miracle.5a18cd61.jpg";